import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../../../../hooks/useBreakpoint";
import { pageGutterSpace, zIndex } from "../../../../../../settings";
import breakpoint from "../../../../../../utils/breakpoint";
import getBorderColor from "../../../../../../utils/getBorderColor";
import getBorderRadius from "../../../../../../utils/getBorderRadius";
import getBoxShadow from "../../../../../../utils/getBoxShadow";
import getColor from "../../../../../../utils/getColor";
import getTextColor from "../../../../../../utils/getTextColor";
import space from "../../../../../../utils/space";
import unit from "../../../../../../utils/unit";
import { cssTextAtm } from "../../../../../atoms/TextAtm/TextAtm.styled";
import { biggerScreenBreakpoint } from "../../../common";
import { headerBackground, headerBackgroundOnBiggerScreen } from "../../Header.settings";
var Overlay = styled.div.withConfig({
  componentId: "sc-1yw40xg-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;padding:", ";background:", ";", "{display:none;}"], zIndex.TableMolHeader, space(pageGutterSpace), getColor(theme, "overlay"), breakpoint(biggerScreenBreakpoint));
});
var Container = styled.div.withConfig({
  componentId: "sc-1yw40xg-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["display:flex;flex-direction:column;align-items:flex-start;", "{width:100%;max-width:", ";padding:0 ", ";border-radius:", ";background:", ";box-shadow:", ";> *{border-bottom:", " solid ", " !important;&:last-child{border-bottom:0 !important;}}}", "{position:absolute;z-index:", ";top:100%;right:0;left:0;margin-top:", ";padding:", " ", ";background:", ";box-shadow:", ";> *{margin-bottom:", ";&:last-child{margin-bottom:0;}}}"], breakpoint("small", biggerScreenBreakpoint), space(60), space(2), getBorderRadius(theme, "large"), getColor(theme, headerBackground), getBoxShadow(theme, "small"), unit(1), getBorderColor(theme, headerBackground, "low"), breakpoint(biggerScreenBreakpoint), zIndex.TableMolHeader, unit(1), space(4), space(3), getColor(theme, headerBackgroundOnBiggerScreen), getBoxShadow(theme, "large"), space(4));
});
var Item = styled.button.withConfig({
  componentId: "sc-1yw40xg-2"
})(function (_ref3) {
  var $isActive = _ref3.$isActive,
    theme = _ref3.theme;
  return css(["", ";width:100%;padding:0;border:0;background:none;text-align:left;cursor:pointer;&:hover{color:", ";}", "{display:flex;align-items:center;justify-content:space-between;padding:", " 0;&::after{content:\"\";width:", ";height:", ";margin:", ";border:", " solid ", ";border-radius:", ";background:", ";box-shadow:0 0 0 ", " ", ";}}", "{padding:", " 0;}", "{", ";color:", ";&:hover{color:", ";}", "}"], cssTextAtm({
    typography: "small4",
    onColor: headerBackground
  }), getTextColor(theme, headerBackground, undefined, "hover"), breakpoint("small", biggerScreenBreakpoint), space(2), unit(15), unit(15), unit(1), unit(2), getColor(theme, "backgroundLight"), getBorderRadius(theme, "huge"), getColor(theme, $isActive ? "success" : "backgroundLight"), unit(1), getBorderColor(theme, headerBackground, "low"), breakpoint("medium", biggerScreenBreakpoint), space(3), breakpoint(biggerScreenBreakpoint), cssTextAtm({
    typography: "small3",
    onColor: headerBackground
  }), getTextColor(theme, headerBackgroundOnBiggerScreen), getTextColor(theme, headerBackgroundOnBiggerScreen, undefined, "hover"), $isActive && css(["display:none;"]));
});
function Dropdown(_ref4) {
  var items = _ref4.items,
    setVisibleDropdownIndex = _ref4.setVisibleDropdownIndex;
  var containerRef = useRef(null);
  var isSmallerScreen = useBreakpoint("small", biggerScreenBreakpoint);
  var handleItemClick = function handleItemClick(onClick, event) {
    onClick(event);
    setVisibleDropdownIndex(null);
  };
  useEffect(function () {
    var handleOutsideClick = function handleOutsideClick(event) {
      var _containerRef$current;
      if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) {
        return;
      }
      setVisibleDropdownIndex(null);
    };
    document.addEventListener("click", handleOutsideClick, true);
    return function () {
      document.removeEventListener("click", handleOutsideClick, true);
    };
  }, [containerRef, setVisibleDropdownIndex]);
  var dropdownJsx = /*#__PURE__*/React.createElement(Container, {
    ref: containerRef
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      onClick: function onClick(event) {
        return handleItemClick(item.onClick, event);
      },
      $isActive: item.isActive,
      key: item.label,
      "data-test-id": "table-dropdown-link-item"
    }, item.label);
  }));
  if (isSmallerScreen) {
    return /*#__PURE__*/React.createElement(Overlay, null, dropdownJsx);
  }
  return dropdownJsx;
}
export default Dropdown;